export default "__VITE_ASSET__BbqSyh3L__"